import React from 'react';

import { DimensionTables } from './components/DimensionTables';
import { PresetPanel } from './components/PresetPanel';
import { DimensionPanelWrapper } from './styled';

export const DimensionPanel: React.FC = () => {
  return (
    <DimensionPanelWrapper>
      <PresetPanel />
      <div style={{ overflowX: 'scroll' }}>
        <DimensionTables />
      </div>
    </DimensionPanelWrapper>
  );
};
